import {CdCarePlanItem} from '../../../interfaces/care/cd-care-plan/cd-care-plan-item';
import {CdAddedMeasureDetail} from '../../../interfaces/care/cd-care-plan/cd-added-measure-detail';
import {CdAddedMeasureDetailFactory} from './cd-added-measure-detail-factory';
import {CdFrequency} from '../../../interfaces/care/cd-care-plan/cd-frequency';
import {CdFrequencyFactory} from './cd-frequency-factory';
import {CdCarePlanItemType} from '../../../enums/care/cd-care-plan/cd-care-plan-item-type';

export class CdCarePlanItemFactory {

  /**
   *
   * @param cdCarePlanItem
   */
  public static fromObject(cdCarePlanItem: any): CdCarePlanItem {
    return new class implements CdCarePlanItem {
      id: number = cdCarePlanItem.id;
      name: string = cdCarePlanItem.name ?? cdCarePlanItem.definition;
      parentId: number = cdCarePlanItem.parent_id;
      type: CdCarePlanItemType = cdCarePlanItem.type;
      cdFrequencies: CdFrequency[] =
        cdCarePlanItem.c_frequencies ? CdFrequencyFactory.fromArray(cdCarePlanItem.c_frequencies) : [];
      alternativeText: string = cdCarePlanItem.measure_alternative_text;
      cdCarePlanId: number = cdCarePlanItem.c_care_plan_id;
      created: string = cdCarePlanItem.created;
      modified: string = cdCarePlanItem.modified;
      comment: string = cdCarePlanItem.comment;
      userId: number = cdCarePlanItem.user_id;
      itemNumber: number = cdCarePlanItem.item_number;
      itemNumberString: string = cdCarePlanItem.item_number_string;
      cdAddedMeasureDetails: CdAddedMeasureDetail[] =
        cdCarePlanItem.measure_details ? CdAddedMeasureDetailFactory.fromArray(cdCarePlanItem.measure_details) : [];

    };
  }

  /**
   *
   * @param cdCarePlanItems
   */
  public static fromArray(cdCarePlanItems: any[]): CdCarePlanItem[] {
    return cdCarePlanItems.map(CdCarePlanItemFactory.fromObject);
  }
}
